import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import WebbLoader from "./webb-loader";

import { GetAuthUser } from "../services/user-accounts";
import { GetRoomList } from "../services/user-accounts";

export default function RoomViewModule(props) {

  const asset = GetAuthUser();
  const { id } = useParams();

  const [loading,setLoading]=useState(true);
  const [data,setData]=useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        setData( (await GetRoomList()).data);
        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset.usid]);

  if (loading) return ( <> <WebbLoader /> </>)

  return (
    <>
      <div className="card rounded-wd border bg-white">

      {data && data.map((item, i) => ( item.enid === id ?
        <div className="d-flex p-3 border-bottom" key={i}>

          <div className="me-auto">
            <p className="fw-bold m-0 p-0">{item.name}</p>
            <p className="small m-0 p-0">{item.shrt}</p>
          </div>
        
          <div className="text-end" style={{width:'fit-content'}}>
            <Link 
              to={`/groups`}
              className="btn btn-sm btn-outline-primary rounded-pill px-4 py-2">
              <small>Back</small>
            </Link>
          </div>
        </div>
      :''))}
      </div>

    </>
  )
}